export default "__VITE_ASSET__BmpQtWwg__"